import {User} from '../../interfaces/core/user';
import {UserRights} from '../../interfaces/core/user-rights';
import {UserRightsFactory} from './user-rights-factory';
import {LightEmployeeFactory} from '../employees/light-employee-factory';
import {LightEmployee} from '../../interfaces/employees/light-employee';

export class UserFactory {

  /**
   *
   * @param user
   */
  public static fromObject(user: any): User {
    return new class implements User {
      id: number = user.id;
      username: string = user.username;
      firstname: null = user.firstname;
      role: string = user.role;
      lastname: string = user.lastname;
      employeeId: number = user.employee_id;
      serviceFacilityIds: number[] = user.service_facility_ids;
      userRights: UserRights = UserRightsFactory.fromObject(user.user_rights);
      employee: LightEmployee = LightEmployeeFactory.fromObject(user.employee);
      emEmploymentId: number = user.em_employment_id;
      profilePicture: string = user.profile_picture;
    };
  }

  /**
   *
   * @param users
   */
  public static fromArray(users: any[]): User[] {
    return users.map(_user => UserFactory.fromObject(_user));
  }
}
